import RecordsRezItem from "./records-rez-item";
import "./records-rez-items.css";

const RecordsRezItems = ({ onClose, items }) => {

  return <div className="records-rez-items">
    {items.map(item => <RecordsRezItem item={item} onClick={() => onClose(item.id)} key={item.id} />)}
  </div>
}

export default RecordsRezItems;